// TODO copied from common lib, DRY violation
// @see https://gitlab.com/techcloud/shared/frontend-common-lib/-/blob/master/src/services/token.js

import cookieStore from './cookie';

interface TokenResponse {
    jwt: string;
    jwtExpiresAt: string;
    refreshToken: string;
    refreshTokenExpiresAt: string;
}

const KEYS = {
  JWT: '__jwt',
  JWT_EXPIRATION: '__jwt-exp',
  REFRESH_TOKEN: '__refresh_token',
  REFRESH_TOKEN_EXPIRATION: '__refresh_token-exp',
};

export interface JwtPayload {
  sub?: string;
  email?: string;
  iat?: number;
  exp?: number;
  [key: string]: unknown;
}

export const parseJwt = (token: string): JwtPayload => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      // eslint-disable-next-line
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

export default {
  getUser() {
    const hasToken = this.hasToken();
    if (hasToken) {
      const token = this.getToken();
      if (token === undefined) {
        return null;
      }
      const { sub, email } = parseJwt(token);

      return {
        id: sub,
        email,
      };
    }

    return null;
  },
  
  removeTokens() {
    cookieStore.remove(KEYS.JWT);
    cookieStore.remove(KEYS.JWT_EXPIRATION);
    cookieStore.remove(KEYS.REFRESH_TOKEN);
    cookieStore.remove(KEYS.REFRESH_TOKEN_EXPIRATION);
  },

  hasRefreshToken() {
    return cookieStore.get(KEYS.REFRESH_TOKEN) !== undefined;
  },

  hasToken() {
    return cookieStore.get(KEYS.JWT) !== undefined;
  },
  
  isTokenExpired() {
    return this.getTokenExpirationDate() < new Date();
  },

  getToken() {
    return cookieStore.get(KEYS.JWT);
  },
  
  getTokenExpirationString() {
    return cookieStore.get(KEYS.JWT_EXPIRATION);
  },

  getTokenExpirationDate() {
    return new Date(this.getTokenExpirationString() ?? '');
  },

  getRefreshToken() {
    return cookieStore.get(KEYS.REFRESH_TOKEN);
  },
  
  getRefreshTokenExpirationString() {
    return cookieStore.get(KEYS.REFRESH_TOKEN_EXPIRATION);
  },

  setTokens({ jwt, jwtExpiresAt, refreshToken, refreshTokenExpiresAt }: TokenResponse) {
    cookieStore.set(KEYS.JWT, jwt, {
      expires: new Date(refreshTokenExpiresAt),
    });

    cookieStore.set(KEYS.JWT_EXPIRATION, jwtExpiresAt, {
      expires: new Date(refreshTokenExpiresAt),
    });

    cookieStore.set(KEYS.REFRESH_TOKEN, refreshToken, {
      expires: new Date(refreshTokenExpiresAt),
    });

    cookieStore.set(KEYS.REFRESH_TOKEN_EXPIRATION, refreshTokenExpiresAt, {
      expires: new Date(refreshTokenExpiresAt),
    });
  },

  verifyTokenWithEmail(email = '') {
    const token = this.getToken();
    if (token === undefined) {
      return false;
    }
    const { email: storedEmail } = parseJwt(token);

    return email === '' || email === storedEmail;
  },
};
